<template>
  <div class="CPmain">
    <div style="width: 720px;margin: 0 auto;overflow: hidden;border-bottom: 3px solid #ff6700;">
      <span style="font-size: 16px;font-weight: bold;color: #1fa1f1;line-height: 33px;">
        订单咨询
      </span>
      <span style="font-size: 16px;color: #333;line-height: 33px;">
        <i class="el-icon-arrow-right"></i>
      </span>
      <span style="font-size: 14px;color: #333;line-height: 33px;font-weight: bold;">
        {{orderxx_information.order_id}}
      </span>
      <span style="font-size: 16px;color: #333;line-height: 33px;">
        <i class="el-icon-arrow-right"></i>
      </span>
      <span style="font-size: 14px;color: #333;line-height: 33px;font-weight: bold;">
        {{orderxx_information.admin_name}}
      </span>
      <span style="float: right;line-height: 33px;">
        <span style="margin-right: 10px;">
          <el-button type="success" icon="el-icon-refresh-right" circle size="mini" @click="getprivateInfors"></el-button>
        </span>
      </span>
    </div>
    <div class="playlistbox_botton" id="divbottom">
      <div style="width: 720px;overflow: hidden;margin: 0 auto;" v-for="(privatelists,i) in privatelist" :key="i">
        <!--时间div-->
        <div style="width: 720px;overflow: hidden;margin: 0 auto;margin-top: 10px;text-align: center;color: #adadad;" v-if="i-1<=0">
          {{privatelists.time*1 | formatDate}}
        </div>
        <div style="width: 720px;overflow: hidden;margin: 0 auto;margin-top: 10px;text-align: center;color: #adadad;" v-else-if="(privatelists.time*1-privatelist[i-1].time*1)<=5000*60">
          <!--
          {{privatelists.time*1 | formatDate}}
          -->
        </div>
        <div style="width: 720px;overflow: hidden;margin: 0 auto;margin-top: 10px;text-align: center;color: #adadad;" v-else>
          {{privatelists.time*1 | formatDate}}
        </div>
        <div v-if="(privatelists.people_id==UserInfor.admin_id) || (privatelists.people_id!=UserInfor.admin_id)">
          <div style="overflow: hidden;" v-if="privatelists.people_id!=UserInfor.admin_id"><!--回复信息-->
            <div style="width: 720px;overflow: hidden;margin: 0 auto;margin-top: 15px;margin-bottom: 15px;">
              <div style="width: 50px;height: 50px;border:1px solid #aaa;float: left;text-align: center;">
                <img :src="privatelists.photo" alt="加载失败" style="width: 50px;height: 50px;margin: 0 auto;">
              </div>
              <div style="margin-top: 10px;float: left;width: 15px;">
                <em class="arr1">◆</em>
              </div>
              <div class="sxinfor">
                {{privatelists.content}}
              </div>
            </div>
          </div>

          <div style="overflow: hidden;" v-else-if="privatelists.people_id==UserInfor.admin_id"><!--我回复信息-->
            <div style="width: 720px;overflow: hidden;margin: 0 auto;margin-top: 15px;margin-bottom: 15px;">
              <div style="width: 50px;height: 50px;border:1px solid #aaa;float: right;text-align: center;">
                <img :src="admin_photo" alt="加载失败" style="width: 50px;height: 50px;margin: 0 auto;">
              </div>
              <div style="margin-top: 10px;float: right;width: 15px;">
                <em class="arr2">◆</em>
              </div>
              <div class="sxinfor1">
                {{privatelists.content}}
              </div>
            </div>
          </div>
        </div>
        <div v-else>

        </div>

      </div>
      <div style="width: 720px;overflow: hidden;margin: 0 auto;height: 5px;" id="bottomstop"></div>
    </div>
    <div style="width: 768px;overflow: hidden;background-color: #FCFCFC;height: 150px;border-top: 1px solid #ddd;">
      <div style="width: 720px;margin: 0 auto;overflow: hidden;margin-top: 20px;">
        <el-input
          type="textarea"
          placeholder="请输入内容"
          v-model="addprivateinfors.content"
          maxlength="200"
          :autosize="{ minRows: 3, maxRows: 4}"
          show-word-limit
          style="width: 720px;"
          @keyup.enter.native="addsprivates">
        </el-input>
      </div>
      <div style="width: 720px;margin: 0 auto;overflow: hidden;margin-top: 5px;">
        <span style="float: right;">
          <el-button type="primary" round size="mini" @click="addsprivates" >发送</el-button>
        </span>
      </div>
    </div>

  </div>
</template>

<script>
  import {commonAPI} from '@/api/commonAPI'
export default {
  data () {
      return {
        //添加信息用的列表
        privateADDList:{
          id:"",
          admin_type:"0",
          u_type:"0",
          people_id:"",
          content:"",
          time:"",
          photo:"",
          p_id:"",
        },
        //信息内容列表
        privatelist:[],
        //新增私信
        //新增私信
        addprivateinfors:{
          content:'',
          order_id:'',
          admin_id:'',
        },

        updatePrivateInfors:{
          p_id:'',
          admin_id:'',
        },

        websock:null,

        //地址参数
        orderxx_information:{
          u_id:'',
          id:'',
          admin_id:'',
          admin_name:'',
          order_id:'',
        },
        //用户相关信息
        UserInfor:{
          id:'',
          u_id:'',
          admin_id:'',
        },
		//客服头像
		admin_photo:'',

      }
    },

    filters: {
          formatDate: function (value) {
            /*返回总体日期*/
            let date = new Date(value);
            let y = date.getFullYear();
            let MM = date.getMonth() + 1;
            MM = MM < 10 ? ('0' + MM) : MM;
            let d = date.getDate();
            d = d < 10 ? ('0' + d) : d;
            let h = date.getHours();
            h = h < 10 ? ('0' + h) : h;
            let m = date.getMinutes();
            m = m < 10 ? ('0' + m) : m;
            let s = date.getSeconds();
            s = s < 10 ? ('0' + s) : s;
            //return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
            /*返回判断日期*/
            let timestamp = (new Date()).valueOf();
            let time=timestamp-value;//时间差
            let minute = 1000*60;
            let hour = minute * 60;
            var day = hour * 24;
            let times="";//内容
            let min = time/minute;//分钟
            let hours = time/hour;//天数
            if(time>=0 && time<minute){
              times="刚刚";
              return times;
            }else if(min>=1 && min<2){
              times=parseInt(min)+"分钟前";
              return times;
            }else if(hours>=0&&hours<24&&new Date(value).toDateString() == new Date().toDateString()){
              return MM+'-'+d+' '+h + ':' + m ;
            }else{
              return y + '-' + MM + '-' + d + ' ' + h + ':' + m;
            }
          }
        },

    mounted(){
      this.judgeLogin();
      },

      created(){
        //this.initwebSocket();
      },


    destroyed () {
      //页面销毁时关闭ws连接
      if(this.websock){
        this.websock.close() // 关闭websocket
      }
    },

    methods: {
      //将WS返回的数据格式化
      /**格式为：内容+发送人ID+发送时间+接收人ID*/
      formatWSdata(data){
        //data="123"+","+"789"+","+"456";
        let datas=data.split(",");
        let id="";
        let admin_type="0";
        let u_type="0";
        let people_id=datas[1];
        let content=datas[0];
        let time=datas[2];
        let photo=this.privatelist[0].photo;
        let p_id="";
        //进行数据整合
        let list=this.privateADDList;
        list.photo=photo;
        list.people_id=people_id;
        list.content=content;
        list.time=time;

        this.privatelist.push(list);
        //console.log(this.privatelist);
        this.$nextTick(function() {
          let div = document.getElementById('divbottom');
          div.scrollTop = div.scrollHeight;
        });
      },
      //进行地址跳转参数获取
      getorderzx_infor(){
        let cc=sessionStorage.getItem("orderzx_infor");
        //console.log(cc)
        if(cc==''||cc==null||cc=='null'){
          this.$notify({
          title: '提示',
          message: '出现错误',
          position: 'bottom-right',
          type: 'error'
          });
          //返回上一页
          this.$router.go(-1);
        }
        cc = JSON.parse(cc);
        this.orderxx_information.id=cc[0];
        this.orderxx_information.admin_id=cc[2];
        this.orderxx_information.admin_name=cc[1];
        this.orderxx_information.order_id=cc[3];
        this.orderxx_information.u_id=this.$store.state.a_id;
        //获取客服头像
        commonAPI('admin_photo', this.UserInfor).then(res => {
        	this.admin_photo=res.data.data;
        })
      },
      //长连接方法
      initwebSocket(){
        let head=window.location.href;
        let heads=head.split(":")
        let one="";
        let two=window.location.hostname;
        if(heads[0]=="http"){
          one="ws://";
          two=two+":8088";
        }else{
          one="wss://";
          two=two+":8443";
        }
        //console.log(heads[0])
        if(typeof(WebSocket) === "undefined"){
          alert("您的浏览器不支持socket")
        }else{
          let url=one+two+"/zjmt/ws?id="+this.$store.state.a_id;
          // 实例化socket
          this.websock = new WebSocket(url)
          this.websock.onopen = this.websocketonopen
          this.websock.onmessage = this.websocketonmessage
          this.websock.onerror = this.websocketonerror
          this.websock.onclose = this.websocketclose
        }
      },
      //连接成功
      websocketonopen(){
      console.log('WebSocket连接成功')
      },
      //接收后端返回的数据
      websocketonmessage(e){
      //console.log(e.data)
      if(e.data!="connectSuccess"){
        this.formatWSdata(e.data);
      }
      // 在这里使用后端返回的数据，对数据进行处理渲染
      },
      //连接建立失败重连
      websocketonerror(e){
      console.log(`连接失败的信息：`, e)
      this.initwebSocket() // 连接失败后尝试重新连接
      },
      //关闭连接
      websocketclose(e){
      console.log('断开连接',e)
      },

      //添加方法
      addsprivates(){
        this.addprivateinfors.admin_id=this.$store.state.a_id;
        this.addprivateinfors.order_id=this.orderxx_information.order_id;
        //console.log(this.addprivateinfors.c_u_id);
        this.addprivateinfors.content = this.addprivateinfors.content.replace(/[\r\n]/g,"");
        if(this.addprivateinfors.content.length<=0){
          this.$message({
            type: 'error',
            message: '请填写内容'
          });
          return false;
        }
        let WSdata="";//传输内容
        let timestamp = (new Date()).getTime();//获取发送时间
        /**格式为：内容+发送人ID+发送时间+接收人ID*/
        WSdata=this.addprivateinfors.content+","+this.addprivateinfors.admin_id+","+timestamp+","+this.orderxx_information.admin_id
        commonAPI('AddAConsulation', this.addprivateinfors).then(res => {
          let data = res.data;
              //console.log(res.data.rows);
              if(this.response.response(data)){
                this.addprivateinfors.content="";
                this.getprivateInfors();
                this.websock.send(WSdata);
              }
            }).catch(error=>{
              this.loading = false;
              this.$notify({//这里采用element ui的一个错误显示效果模板
                title: '提示',
                message: error.message,
                position: 'bottom-right',
                type: 'error'
              });
          });
      },
      //获取私信详细信息
      getprivateInfors(){
        this.getorderzx_infor();
        commonAPI('queryConsulation_information', this.orderxx_information).then(res => {
          this.privatelist=res.data.data.rows;
          this.$nextTick(function() {
            let div = document.getElementById('divbottom');
            div.scrollTop = div.scrollHeight;
          });
          //更改查看状态
          this.orderxx_information.consulation_id=this.orderxx_information.id;
          this.orderxx_information.people_id=this.orderxx_information.admin_id;
          //commonAPI('updateConsulation_information', this.orderxx_information).then(res => {})
        })
      },
      //获取登录状态
      judgeLogin(){
        this.initwebSocket();
        this.UserInfor.admin_id=this.$store.state.a_id;
        this.getprivateInfors();
      },
    },
  }
</script>

<style scoped>
  a{
    color: #000000;
  }
  a:hover{
    color: #ff6700;
  }
  .CPmain{
    width: 768px;
    height: 800px;
    overflow: hidden;
  }
  .openprivate{
    width: 720px;
    overflow: hidden;
  }
  .openprivate:hover{
    width: 720px;
    overflow: hidden;
    background-color: #F4F4F4;
  }
  .title{
  width:550px;
  overflow:hidden;
  text-overflow:ellipsis;
  white-space:nowrap;
  word-break:keep-all;
  color: #a2a2a2;
  }
  .logindivpp{
    position: fixed;
    top: 25%;
    left:0;
    right:0;
    bottom: 0;
    margin:0 auto;
    padding: 20px;
    border: 0px solid #ddd;
    z-index:2002;
    overflow: auto;
    text-align: center;
    display:none;
  }
  .loginFormpp{
    margin: 0 auto;
    width: 550px;
    background-color: #fff;
    -webkit-box-shadow: #333 0px 5px 5px;
    -moz-box-shadow: #333 0px 5px 5px;
    box-shadow: #333 0px 5px 5px;
  }
  .loginFormpp a{
    color: #fff;
  }
  .loginFormpp a:hover{
    color: #d6d6d6;
  }
  .playlistbox_botton{
    width: 768px;
    bottom:0;
    height: 550px;
    margin: 0 auto;
    overflow-y: scroll;
  }
  /**滚动条样式*/
  .playlistbox_botton::-webkit-scrollbar{
    width: 5px;
  }
  .playlistbox_botton::-webkit-scrollbar-thumb{
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
    background: #535353;
  }
  .playlistbox_botton::-webkit-scrollbar-thumb{
    -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
    border-radius: 10px;
    background: #EDEDED;
  }
  .sxinfor{
    max-width: 450px;
    min-height:20px;
    margin-left: 5px;
    overflow: hidden;
    float: left;
    background-color: #79ACE5;
    color: #fff;
    padding: 15px;
    border-radius: 12px;
  }
  .sxinfor1{
    max-width: 450px;
    min-height:20px;
    margin-right: 5px;
    overflow: hidden;
    float: right;
    background-color: #79ACE5;
    color: #fff;
    padding: 15px;
    border-radius: 12px;
    word-wrap:break-word;
  }
  .arr1{
    display: block;
    font-family: "SimSun";
    font-size: 15px;
    font-style: normal;
    font-weight: normal;
    height: 15px;
    line-height: normal;
    margin-left: 0.745rem;
    color: #79ACE5;
  }
  .arr2{
    display: block;
    font-family: "SimSun";
    font-size: 15px;
    font-style: normal;
    font-weight: normal;
    height: 15px;
    line-height: normal;
    margin-left: -0.735rem;
    color: #79ACE5;
  }
</style>



// WEBPACK FOOTER //
// src/admin/views/consulation_admin/AConsulationinfor.vue